import React from 'react';
import { useCustomComponent } from '@/hooks';

const ArrowComponent: React.FC = () => {
  return <div className="peptalk-floating-message-arrow"></div>;
};

export const Arrow: React.FC = () => {
  const Component = useCustomComponent({
    componentName: 'FloatingMessageArrow',
    Component: ArrowComponent,
  });

  return <Component />;
};
